import { useFormContext } from 'react-hook-form';

import { TextInput } from 'shared_DEPRECATED/components/Form/Input';

export const NextSessionFormMiroBoardLinkEdit = () => {
  const { register } = useFormContext();

  return (
    <TextInput
      {...register(`coachingClientNote.dashboardLink`)}
      //@ts-ignore
      placeholder="Add miro link here"
      dataTestid="miro-link-text-field"
    />
  );
};
